import { Component } from 'react';
import { validatePassword } from '../../../services/utils/form';
import './smart-input.css';

class SmartInput extends Component {
  clear() {
    this.set('');
  }

  set(value) {
    const { config, on_change } = this.props;
    on_change(config.name, value);
  }

  update(e) {
    const newValue = e.target.value;
    this.set(newValue);
  }

  render() {
    const { config, value } = this.props;

    let type = 'text';
    if (config.type) {
      type = config.type;
    }

    let passwordField = false;
    let passwordIndicatorClass;
    let passwordStrengthText = '';
    let passwordStrengthClass = '';

    if (config.type === 'password') {
      passwordField = true;
      const passwordStrength = validatePassword(value || '');
      if (passwordStrength === 'strong') {
        passwordStrengthText = 'Strong';
        passwordStrengthClass = 'green';
      } else if (passwordStrength === 'medium') {
        passwordStrengthText = 'Medium';
        passwordStrengthClass = 'yellow';
      } else {
        passwordStrengthText = 'Weak';
        passwordStrengthClass = 'red';
      }
      passwordIndicatorClass = 'password_indicator ' + passwordStrengthClass;
    }

    const label = config.label ? config.label : false;

    let required = false;

    if (config.required) {
      required = true;
    }

    let inputClass = 'smart_input';
    let containerClass = 'smart_input_container';

    if (config.wide) {
      inputClass += ' wide';
      containerClass += ' wide';
    }

    if (config.inline) {
      inputClass += ' inline';
      containerClass += ' inline';
    }

    if (config.centered) {
      containerClass += ' centered';
    }

    if (label) {
      return (
        <div className={containerClass}>
          <label className="smart_input_label">
            {label}
            {required && (
              <span className="smart_input_required">
                <i className="fa fa-asterisk"></i>
              </span>
            )}
          </label>
          <input
            className={inputClass}
            type={type}
            onChange={this.update.bind(this)}
            value={value || ''}
            autoComplete="off"
          />

          {value?.length > 0 && passwordField && <div className={passwordIndicatorClass}>{passwordStrengthText}</div>}
        </div>
      );
    }
  }
}

export default SmartInput;
